import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import i18n from './i18n'
import router from './routes'
import globalUtil from './utils/global'

import '@/components/index'
import 'babel-polyfill'
import 'normalize.css/normalize.css'
import 'element-ui/lib/theme-chalk/display.css'
import './assets/theme/index.scss'
import './assets/css/index.scss'
import './assets/icon'
Vue.config.productionTip = false
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

Vue.use(globalUtil)

new Vue({
  render: h => h(App),
  i18n,
  router
}).$mount('#app')
